/**
 * 安全配置 - 修改主页
 */
import { ConfigProvider } from 'antd';
import { useLoaderData } from 'react-router-dom'
import cookie from 'react-cookies';
import CNF from '../../incs/Config.js';

import SecurityUpdateNav from './SecurityUpdateNav.js';
import SecurityUpdateEntity from './SecurityUpdateEntity.js';

//  检查参数合法性
const checkParamas = (params) => {
    /***
     * 检验地址的合法性
     * 1.检验时间戳的合法性，相差时间不能超过 Config 中设置的 maxAge 值
     * 2.检验参数的合法性
     */
    let rtv = true;
    while (true) {
        if (!params.name || params.name.split('&').length < 2) {
            rtv = false;
            break;
        }
        let ts = params.name.split('&')[1].split('=');
        if (ts.length < 2) {
            rtv = false;
            break;
        }
        let dt = Date.parse(new Date()) - ts[1] * CNF.tDivisor;
        if (dt < 0 || dt > CNF.maxAge * 1000) {
            rtv = false;
            break;
        }
        let m = params.name.split('&')[0].split('=');
        if (m.length < 2) {
            rtv = false;
            break;
        };
        break;
    }
    return rtv
}

const SecurityUpdate = () => {
    if (!cookie.load(CNF.cookies.keyId) || !cookie.load(CNF.cookies.keyUid)) {
        //  未登录跳转至登录界面
        window.location.href = CNF.accountUrl;
    }
    const params = useLoaderData();
    if (!checkParamas(params)) {
        //  检查参数异常返回到安全设置界面
        window.location.href = '/users/security';
    };
    //  获取修改类型
    let m = params.name.split('&')[0].split('=');
    var title = '';
    switch (m[1]) {
        case 'password':
            title = '密码';
            break;
        case 'phone':
            title = '手机';
            break;
        case 'email':
            title = '邮箱';
            break;
        default:
            this.props.history.push('/users/security');
            break;
    }

    return (
        <ConfigProvider
            variant='outlined'
            theme={{
                token: {
                    colorPrimary: cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0],
                },
            }}
        >
            {/* <ServiceReleaseMessage themeColor={cookie.load(CNF.cookies.keyThemeColor)} serInfos={[]} /> */}
            <SecurityUpdateNav
                username={cookie.load(CNF.cookies.keyId)}
                uid={cookie.load(CNF.cookies.keyUid)}
                title={title}
            />
            <SecurityUpdateEntity
                username={cookie.load(CNF.cookies.keyId)}
                uid={cookie.load(CNF.cookies.keyUid)}
                title={title}
                m={m[1]}
            />
        </ConfigProvider>
    )
}

export default SecurityUpdate;